import { Controller } from "@hotwired/stimulus"

// FAQ accordion. Multiple items can be open at once, and "Expand all" flips to
// "Collapse all" once everything is open (and vice versa on click).
export default class extends Controller {
  static targets = ["item", "toggleAllLabel"]

  toggle(event) {
    this.#setOpen(event.currentTarget.closest(".mk-faq-item"), (item) => !this.#isOpen(item))
    this.#syncToggleAllLabel()
  }

  toggleAll() {
    const openEverything = this.itemTargets.some((item) => !this.#isOpen(item))
    this.itemTargets.forEach((item) => this.#setOpen(item, () => openEverything))
    this.#syncToggleAllLabel()
  }

  #isOpen(item) {
    return item.classList.contains("is-open")
  }

  #setOpen(item, decide) {
    const open = decide(item)
    item.classList.toggle("is-open", open)
    item.querySelector(".mk-faq-question").setAttribute("aria-expanded", open)
  }

  #syncToggleAllLabel() {
    const allOpen = this.itemTargets.every((item) => this.#isOpen(item))
    this.toggleAllLabelTarget.textContent = allOpen ? "Collapse all" : "Expand all"
  }
}
